import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New design variables introduced 11-12-2019 */

    /* New design variables introduced 7-16-2020 */
}
:root {
    @lost gutter 24px;

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    @custom-media --small-up (min-width: 322px);
    @custom-media --small-down (max-width: 320px);
    @custom-media --small-only (max-width: 320px);

    @custom-media --medium-up (min-width: 722px);
    @custom-media --medium-down (max-width: 720px);
    @custom-media --medium-only (max-width: 720px) and (min-width: 321.001);

    @custom-media --large-up (min-width: 1082px);
    @custom-media --large-down (max-width: 1080px);
    @custom-media --large-only (max-width: 1080px) and (min-width: 721.001);

    @custom-media --xlarge-up (min-width: 1442px);
    @custom-media --xlarge-down (max-width: 1440px);
    @custom-media --xlarge-only (max-width: 1440px) and (min-width: 1081.001);

    @custom-media --xxlarge-up (min-width: 1922px);
    @custom-media --xxlarge-down (max-width: 1920px);
    @custom-media --xxlarge-only (max-width: 1920px) and (min-width: 1441.001);

    @custom-media --small-up-height (min-height: 322px);
    @custom-media --small-down-height (max-height: 320px);
    @custom-media --small-only-height (max-height: 320px);

    @custom-media --medium-up-height (min-height: 722px);
    @custom-media --medium-down-height (max-height: 720px);
    @custom-media --medium-only-height (max-height: 720px) and (min-height: 321.001);

    @custom-media --large-up-height (min-height: 1082px);
    @custom-media --large-down-height (max-height: 1080px);
    @custom-media --large-only-height (max-height: 1080px) and (min-height: 721.001);

    @custom-media --xlarge-up-height (min-height: 1442px);
    @custom-media --xlarge-down-height (max-height: 1440px);
    @custom-media --xlarge-only-height (max-height: 1440px) and (min-height: 1081.001);

    @custom-media --xxlarge-up-height (min-height: 1922px);
    @custom-media --xxlarge-down-height (max-height: 1920px);
    @custom-media --xxlarge-only-height (max-height: 1920px) and (min-height: 1441.001);
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
button {
    outline: 0;
    border: 0;
    background: none;
    padding: 0;
    font-family: inherit;
    font-style: inherit;
    cursor: pointer;
}
.horizontal .options {
  display: flex;
}
.horizontal .option {
  flex: 1;
  text-align: center;
}
.wrapper {
  position: relative;
  padding-bottom: 8px;
  margin-bottom: calc(8px * 3);
}
.error-msg {
  position: absolute;
  bottom: 0px;
  color: #cc1f1f;
  font-size: 14px;
}
fieldset {
  margin-bottom: calc(8px * 2);
  border: 1px solid #eeeeee;
  position: relative;
  padding-top: calc(8px * 3);
  padding-bottom: calc(8px * 2);
}
fieldset.error {
  border-color: #cc1f1f;
}
fieldset legend {
  color: #475359;
}
fieldset label {
  display: block;
  color: #475359;
  font-size: 16px;
  margin-bottom: 8px;
}
fieldset.vertical label {
  display: inline-block;
}
fieldset.vertical {
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
}
fieldset.vertical input {
  width: auto;
}
`;

export default styles;